@for (info of infoMessages$ | async; track info) {
<div class="alert alert-info" data-testing-id="info-messages">
  {{ info.message }}
  @if (info.causes) { @for (cause of info.causes; track cause) {
  <p>
    {{ cause.message }}
  </p>
  } }
</div>
}
